import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TimezoneComp;

class Timezone extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: TimezoneComp};
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/timezone-comp" */
            "../../../components/javascript/zcat-components/timezone-comp"
        ).then(function(res) {
            TimezoneComp = res.TimezoneComp;
        }));

        
;
    }
}

export {Timezone};

